import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {SharedModule} from "../../shared/shared.module";
import {StoreModule} from "@ngrx/store";
import {reducer} from "./core/super-admin.reducer";
import {EffectsModule} from "@ngrx/effects";
import {SuperAdminEffects} from "./core/super-admin.effects";
import {SuperAdminRoutingModule} from "./super-admin.routing";



@NgModule({
  declarations: [
  ],
  imports: [
    CommonModule,
    SharedModule,
    SuperAdminRoutingModule,
    StoreModule.forFeature('school-voices.super-admin', reducer),
    EffectsModule.forFeature(
      [SuperAdminEffects]
    ),
  ]
})
export class SuperAdminModule { }
